import { render, staticRenderFns } from "./EmployeeIssueStatistics.vue?vue&type=template&id=9d06d458&scoped=true&"
import script from "./EmployeeIssueStatistics.vue?vue&type=script&lang=js&"
export * from "./EmployeeIssueStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d06d458",
  null
  
)

export default component.exports